import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { installChunkLoadRecovery } from './lib/chunkLoadRecovery'
import { initSentry } from './lib/sentry.js'

initSentry()
installChunkLoadRecovery()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
